module.exports = __webpack_public_path__ + "static/media/pro-pic.77b12542.png";